import { useEffect, useState, useCallback } from 'react'
import {
  getService29VehicleCerts,
  VehicleCert,
  VehicleCertQuery
} from '../../services/endpoints/service29'

const useCertList = (isActive: boolean, query: VehicleCertQuery) => {
  const [certs, setCerts] = useState<VehicleCert[]>([])
  const [total, setTotal] = useState(0)
  const [error, setError] = useState<string | null>(null)

  const fetchCerts = useCallback(async () => {
    if (!isActive) {
      setCerts([])
      setTotal(0)
      return
    }
    try {
      const res = await getService29VehicleCerts(query)
      setCerts(res.data)
      setTotal(res.paging.total)
    } catch (err) {
      setError(err?.message ?? 'Failed to load certificates')
    }
  }, [query, isActive])

  useEffect(() => {
    const controller = new AbortController()
    void fetchCerts()
    return () => controller.abort()
  }, [fetchCerts])

  return { certs, setCerts, total, error, refresh: fetchCerts }
}

export default useCertList
